import script from "./MonCompte.vue?vue&type=script&setup=true&lang=js"
export * from "./MonCompte.vue?vue&type=script&setup=true&lang=js"

import "./MonCompte.vue?vue&type=style&index=0&id=27394eb6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27394eb6"]])

export default __exports__